import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormularioBalizaComponent } from '../formularios/FormularioBaliza.component';


import { FormsModule } from '@angular/forms';

import { TranslateModule } from 'ng2-translate';

import {
	DropdownModule,
	CalendarModule,
	MessagesModule
} from 'primeng/primeng';
// Para componentes que vana ser cargados desde mas de una vista es necesario definir un modullo e importar ese modulo desde la vista que se desee usar el componente

@NgModule(
    {
        imports: [
            CommonModule,
            FormsModule,
            TranslateModule,
			CalendarModule,
			MessagesModule,
			DropdownModule
        ],
        exports: [
            FormularioBalizaComponent,

    ],
        declarations: [
            FormularioBalizaComponent,
        ],
        providers: [],
    })

    export class  FormularioBalizaModule{
 }



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/formularios.module.ts